let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iFEfD")).then(() => parcelRequire('26itv'));